export default function generateNav(type, children) {
  const navData = type.map((typeEdge) => {
    const { slug, title } = typeEdge.node.childMarkdownRemark.frontmatter;

    return {
      title,
      slug,
      children: children
        ? children
            .filter((deviceEdge) => {
              const { brand } = deviceEdge.node.childMarkdownRemark.frontmatter;
              return slug === brand;
            })
            .map((edge) => ({
              title: edge.node.childMarkdownRemark.frontmatter.title,
              slug: edge.node.childMarkdownRemark.frontmatter.slug,
            }))
        : undefined,
    };
  });
  return navData;
}
